export enum WebcastType {
	Rev = 'Rev',
	WebexEvents = 'WebexEvents'
}
